import style from "./style.module.scss";

function ContactForm() {
    return (
        <div className={style.root}>
            <div className={style.whiteContainer}>
                <div className={style.photoHalf}></div>
                <div className={style.textHalf}>
                    <div className={style.content}>
                        <div className={style.yellowTitle + " " + style.bigTitle + " " + style.titles}>GRACIAS</div>
                        <div className={style.blackTitle + " " + style.titles}>Wij kijken uit naar uw reactie! Aarzel niet en zend een mail naar</div>
                        <div className={style.yellowTitle + " " + style.titles}>philippe@xtracosta.com</div>
                        <span>of bel ons op </span>
                        <span className={style.yellowTitle}>0468.150.212</span>

                        <div className={style.smallTextBox}>
                            <div className={style.smallTextBlock + " " + style.smallText}>Gelieve het onderstaande formulier in te vullen, voor meer</div>
                            <div className={style.smallTextBlock + " " + style.smallText}>vrijblijvende informatie over Xtracos</div>
                        </div>

                        <div className={style.form}>
                            <div className={style.inputs + " " + style.smallerText}>
                                <input type="text" placeholder="Naam Bedrijf*" />
                                <input type="text" placeholder="Naam Keep *" />
                                <input type="text" placeholder="Tel. *" />
                                <input type="text" placeholder="Email *" />
                            </div>
                            <textarea className={style.smallText} placeholder="Bericht *"/>

                            <div className={style.buttonContainer + " " + style.smallerText}>
                                <input type="button" value="ZENDEN"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;